import React, { Component } from 'react';
import isEqual from "lodash/isEqual";
import Tree, { TreeNode } from 'rc-tree';
import { BsyUtils } from '../../utils/Utils'
// import { post } from '../../utils/http'

import { theme as customTheme } from './theme/index';

import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlertMenu from "../BsyAlertMenu";

import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

// import FileExplorerTheme from '../theme';

// import { data as DeptData } from '../../example/deptdata'

import './index.css'

//npm install react-sortable-tree --save
//解决报错
//https://blog.csdn.net/ligaoming_123/article/details/113876004
// 1、安装  npm i patch-package --save-dev
// 2、修改代码。react-sortable-tree的依赖包node_modules/frontend-collective-react-dnd-scrollzone/lib/index.jsx
// // this.container = (0, _reactDom.findDOMNode)(this.wrappedInstance.current);
// // 修改为
// this.container = this.wrappedInstance.current;
// 3、生成补丁 npx patch-package frontend-collective-react-dnd-scrollzone
// 4、集成项目中。
// 在package.json中scripts中添加"postinstall": "patch-package"。
//  "scripts": {
// +  "postinstall": "patch-package"
//  }

const keyFromTreeIndex = ({ treeIndex }) => treeIndex;

export default class BsyDomTree extends Component {

  static defaultProps = {
    idKey: "departmentId",
  }

  constructor(props) {
    super(props);
    const treeData = [...this.deepCopy(this.getTreeData(props.departments))]
    this.state = {
      expandedKeys: [1],
      treeData: treeData,
      rowHeight: 36,
      nodeClicked: null,
      selectKey: null
    };
  }

  deepCopy = (obj, visited = new WeakMap()) => {
    // 如果 obj 是 null 或不是对象，直接返回它自身
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    // 如果 obj 已经被访问过，返回它的副本以避免循环引用
    if (visited.has(obj)) {
      return visited.get(obj);
    }

    // 根据 obj 的类型创建一个新的空对象或数组
    let copy;
    if (Array.isArray(obj)) {
      copy = [];
    } else {
      copy = Object.create(Object.getPrototypeOf(obj));
    }

    // 记录访问过的 obj，以便处理循环引用
    visited.set(obj, copy);

    // 遍历 obj 的属性或数组元素并进行递归深拷贝
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        copy[key] = this.deepCopy(obj[key], visited);
      }
    }

    return copy;
  }

  // UNSAFE_componentWillReceiveProps(nextProps, nextContext) {

  //   if (!isEqual(this.props.departments, nextProps.departments)) {
  //     const newtreeData = [...this.deepCopy(this.getTreeData(nextProps.departments))]
  //     this.setState({
  //       treeData: newtreeData,
  //       departments: nextProps.departments,
  //       nodeClicked: nextProps.selectDept,
  //       selectKey: nextProps.selectKey
  //     })
  //   } else {
  //     this.setState({
  //       departments: nextProps.departments,
  //       nodeClicked: nextProps.selectDept,
  //       selectKey: nextProps.selectKey
  //     })
  //   }

  // }

  componentDidMount(){
    this.props.domTreeContext && this.props.domTreeContext(this)
  }

  transformToTreeFormat = (b) => {
    let simpleData = {
      enable: true,
      idKey: this.props.idKey,
      pIdKey: "parentId"
    }
    var c, d, e = simpleData.idKey, f = simpleData.pIdKey, g = 'children';
    if (!e || "" == e || !b)
      return [];
    if (Array.isArray(b)) {
      var h = []
        , i = [];
      for (c = 0, d = b.length; c < d; c++) {
        i[b[c][e]] = b[c];
      }

      for (c = 0, d = b.length; c < d; c++) {

        if (i[b[c][f]] && b[c][e] != b[c][f]) {
          i[b[c][f]][g] || (i[b[c][f]][g] = [])


          b[c].title = b[c].name;
          b[c].key = b[c][simpleData.idKey];
          i[b[c][f]][g].push(b[c])
        } else {
          b[c].title = b[c].name;
          b[c].key = b[c][simpleData.idKey];
          h.push(b[c])
        }

      }
      return h
    }
    b.title = b.name;
    b.key = b[simpleData.idKey];
    return [b]
  }

  //构建 tree数据 
  getTreeData = (departments) => {
    // const { departments } = DeptData;
    if (departments.length == 0)
      return [];
    let resultArr = this.transformToTreeFormat(departments);

    resultArr = resultArr.map((data,index)=>{
      data.expanded = true;
      return data
    })
    return resultArr;
  }

  onChangeValue = (treeData) => {
    this.setState(treeData);
    // this.onSyncGridWidth();
    // this.props.onChangeVal(JSON.stringify(treeData));
  }
  eventCustMent = (type, node, path, key, event) => {
    switch (type) {
      case "add": {
        const _this = this;
        window.FX.Msg.nAlter({
          renderEl: window.$(event.target),
          title: React.language("dept.add"),
          name: "",
          text4Ok: React.language("add"),
          placeholder: React.language('dept.name.required'),
          onOk: function (c2) {
            var value = "";
            if (!!c2.checkValidate()) {
              value = c2.getValue();
            }
            if (!value) {
              tipAlert({
                type: "warning",
                msg: React.language('department.name.empty')
              })
              return;
            }

            React.axios("/corp/department/create",
              { "name": value, "parentId": node.departmentId })
              .then(res => {
                // const {
                //   treeData
                // } = addNodeUnderParent({
                //   treeData: _this.state.treeData,
                //   parentKey: key,
                //   newNode: { ...res.data, ...{title: res.data.name} },
                //   getNodeKey: keyFromTreeIndex,
                // });
                // _this.setState({ treeData: treeData })
                _this.props.getDeptList && _this.props.getDeptList();
              }).catch(res => {

            })
          }
        })
        break;
      }
      case "del": {
        const _this = this;
        if(_this.props.onRemoveNode){
          _this.props.onRemoveNode(node);
          return
        }
        window.FX.Msg.alert({
          type: "warning",
          title: React.language("delete.confirm", {
            name: node.name
          }),
          text4Ok: React.language("delete"),
          msg: React.language("dept.delete.tip"),
          onOk: function () {


            React.axios("/corp/department/" + node.departmentId + "/remove", {
              departmentId: node.departmentId
            }).then(res => {
              // const {
              //   treeData
              // } = removeNode({
              //   treeData: _this.state.treeData,
              //   path: path,
              //   getNodeKey: keyFromTreeIndex,
              // })
              // _this.setState({ treeData: treeData })
              _this.props.getDeptList && _this.props.getDeptList();
            }).catch(res => {

            })
          }
        });
        break;
      }
      case 'detail': {
        node.key = node.data.key;
        this.handleNodeClick(node);
        break;
      }
      case 'rename': {
        const _this = this;
        window.FX.Msg.nAlter({
          renderEl: window.$(event.target),
          title: React.language("edit.dept.name"),
          name: node.title,
          placeholder: React.language("name.placeholder"),
          onOk: function (c2) {
            var value = "";
            if (!!c2.checkValidate()) {
              value = c2.getValue();
            }
            if (!value) {
              tipAlert({
                type: "warning",
                msg: React.language('department.name.empty')
              })
              return;
            }
            if (node.title === value) {
              return;
            }

            React.axios("/corp/department/" + node.departmentId + "/edit",
              { "name": value, "departmentId": node.departmentId })
              .then(res => {
                // const treeData = changeNodeAtPath({
                //   treeData: _this.state.treeData,
                //   newNode: ({ node }) => ({ ...node, title: value }),
                //   path: path,
                //   getNodeKey: keyFromTreeIndex,
                // });
                // _this.setState({ treeData: treeData })
                _this.props.getDeptList && _this.props.getDeptList();
              }).catch(res => {

            })
          }
        })
        break;
      }
      case 'ID': {
        window.FX.Msg.nAlter({
          renderEl: window.$(event.target),
          title: React.language("department.id"),
          name: node._id,
          mode: "show"
        })
        break;
      }
      case 'number':{
        window.FX.Msg.nAlter({
          renderEl: window.$(event.target),
          title: React.language("department")  +React.language("serial.number"),
          name: node.departmentId,
          mode: "show"
        })
        break;
      }
      default: {

      }
    }
  }
  handleCustomMenu = (rowInfo) => {
    // const {node} = rowInfo;
    return (e) => {
      e.stopPropagation();
      e.preventDefault();
      const { node, path } = rowInfo;
      this.setState({ nodeClicked: rowInfo[this.props.idKey] })
      if(this.props.handleCustomMenu){
        this.props.handleCustomMenu(rowInfo, e);
        return
      }
      let menu = [
      {
        text: React.language('dept.sub.add'),
        colorType: "",
        click: () => {
          this.eventCustMent('add', rowInfo, path, rowInfo ? rowInfo.treeIndex : null,e);
        }
      }, {
        text: React.language('rename'),
        colorType: "",
        click: () => {
          this.eventCustMent('rename', rowInfo, path,null,e);
        }
      }, {
        text: React.language('department.ID'),
        colorType: "",
        line:true,
        click: () => {
          this.eventCustMent('ID', rowInfo, path,null,e);
        }
      },
        {
          text: React.language('serial.number'),
          colorType: "",
          click: () => {
            this.eventCustMent('number', rowInfo, path,null,e);
          }
        }
      ];
      if(this.props.deptRemove){
        menu = [{
          text: React.language('dept.sub.add'),
          colorType: "",
          click: () => {
            this.eventCustMent('add', rowInfo, path, rowInfo ? rowInfo.treeIndex : null,e);
          }
        }, {
          text: React.language('rename'),
          colorType: "",
          click: () => {
            this.eventCustMent('rename', rowInfo, path,null,e);
          }
        }, {
          text: React.language('del.department'),
          colorType: "red",
          click: () => {
            this.eventCustMent('del', rowInfo, path,null,e);
          }
        }, {
          text: React.language('department.ID'),
          colorType: "",
          line:true,
          click: () => {
            this.eventCustMent('ID', rowInfo, path,null,e);
          }
        },
          {
            text: React.language('serial.number'),
            colorType: "",
            click: () => {
              this.eventCustMent('number', rowInfo, path,null,e);
            }
          }
        ]
      }
      if(!BsyUtils.isCommon()) {
        menu = [{
          text: React.language('department.ID'),
          colorType: "",
          line:true,
          click: () => {
            this.eventCustMent('ID', rowInfo, path,null,e);
          }
        },
          {
            text: React.language('serial.number'),
            colorType: "",
            click: () => {
              this.eventCustMent('number', rowInfo, path,null,e);
            }
          }
        ]
      }
      if(this.props.menuItem){
        menu = [];
        this.props.menuItem.indexOf("detail") > -1 && menu.push({
          text: React.language('detail'),
          colorType: "",
          click: () => {
            this.eventCustMent('detail', rowInfo, path,null,e);
          }
        })
        this.props.menuItem.indexOf("del") > -1 && menu.push({
          text: React.language('remove.out'),
          colorType: "red",
          click: () => {
            this.eventCustMent('del', rowInfo, path,null,e);
          }
        })
      }
      BsyAlertMenu({
        item: menu,
        // renderEl: e.currentTarget,
        width: 140,
        target: e.currentTarget,

      })
      rowInfo.key = rowInfo.data.key;
      !this.props.reClick && this.handleNodeClick(rowInfo);
      return false;
    }
  }

  handleNodeClick = (e, k) => {
    if(this.state.nodeClicked === e[this.props.idKey] && !this.props.reClick){
      return
    }
    this.setState({ nodeClicked: e[this.props.idKey], selectKey: e.key })
    if (this.props.nodeClick) {

      this.props.nodeClick(e)
    }
    return false
  }

  updataTree = (data) =>{
    const treeData = [...this.deepCopy(this.getTreeData(data))]
    this.setState({treeData})
  }

  //寻找新元素所有的位置
  findNode = (newTreeData, node) => {

    // let n = newTreeData.children.length;
    let result = {
      parentId: (newTreeData.dragOver || !newTreeData.dragOverGapBottom) ? newTreeData[this.props.idKey] : newTreeData.parentId,
      [this.props.idKey]: node[this.props.idKey],
      prev: newTreeData.dragOver ? null : !newTreeData.dragOverGapBottom ? newTreeData.children ? newTreeData.children[newTreeData.children.length - 1][this.props.idKey] : 0 : newTreeData[this.props.idKey],
    };
    return result;

  }


  deepClone = obj => {
    const isObject = args => (typeof args === 'object' || typeof args === 'function') && typeof args !== null
    if (!isObject) throw new Error('Not Reference Types')
    let newObj = Array.isArray(obj) ? [...obj] : { ...obj }
    Reflect.ownKeys(newObj).map(key => {
      newObj[key] = isObject(obj[key]) ? this.deepClone(obj[key]) : obj[key]
    })
    return newObj
  }
  deletedData = false;
  addedData = false;
  fAddedData = false;
  changeSortData = (treeData, dragNode, parentId, departmentId, prev, expanded) =>{
    console.log(treeData)
    const updatedTree = treeData;
    if(parentId === updatedTree[this.props.idKey] && !updatedTree.children){
      updatedTree.children = [];
      updatedTree.expanded = true;
      expanded.push(updatedTree.key);
    }
    if(updatedTree.children){
      if(prev === null){
        if(parentId === updatedTree[this.props.idKey] && !this.fAddedData){
          const l = 0;
          this.addedData = true;
          this.fAddedData = true;
          updatedTree.children.splice(l, 0, dragNode);
          dragNode.isNew = true;
          if(this.deletedData){
            this.deletedData = false;
            this.addedData = false;
          }
        }
      }
      for(let i = 0; i < (updatedTree.children ? updatedTree.children.length : 0); i++){
        if(updatedTree.children[i]){
          updatedTree.children[i] = this.changeSortData(updatedTree.children[i], dragNode, parentId, departmentId, prev, expanded);
        }
        if(updatedTree.children[i][this.props.idKey] === dragNode[this.props.idKey] && !updatedTree.children[i].isNew && !this.deletedData){
          updatedTree.children.splice(i, 1);
          this.deletedData = true;
          if (updatedTree.children.length === 0) {
            updatedTree.expanded = false;
            updatedTree.children = undefined;
            treeData.children = undefined;
            treeData.expanded = false;
            expanded.splice(expanded.indexOf(updatedTree.key), 1);
            i = 0;
          }else{
            i--;
          }

          if(this.addedData){
            this.deletedData = false;
            this.addedData = false;
          }
        }else{
          if(prev === null && parentId === updatedTree.children[i][this.props.idKey] && !this.fAddedData){
            const l = 0;
            this.addedData = true;
            updatedTree.children[i].children.splice(l, 0, dragNode);
            dragNode.isNew = true;
            i++;
            if(this.deletedData){
              this.deletedData = false;
              this.addedData = false;
            }
          }else if(updatedTree.children[i][this.props.idKey] === prev && !this.fAddedData){
            const l = i + 1;
            this.addedData = true;
            updatedTree.children.splice(l, 0, dragNode);
            dragNode.isNew = true;
            i++;
            if(this.deletedData){
              this.deletedData = false;
              this.addedData = false;
            }
          }
        }
      }
    }

    return updatedTree
  }

  handleMoveNode = (node) => {
    const { treeData, expandedKeys } = this.state;
    const oldTreeData = this.deepClone(treeData);
    const oldExpandedKeys = this.deepClone(expandedKeys);


    const result = this.findNode(node.node, node.dragNode);
    if (node.dropPosition < 0 || result.parentId === result[this.props.idKey]) {
      this.setState({ treeData: oldTreeData, expandedKeys: oldExpandedKeys });
      return;
    }

    const children = [];
    const expanded = expandedKeys;
    const newData = this.changeSortData(treeData[0],node.dragNode , result.parentId, result[this.props.idKey], result.prev, expanded);
    node.dragNode.isNew = false;
    this.fAddedData = false;
    this.setState({ expandedKeys: expanded, treeData: [newData] }, () => {
      if (!BsyUtils.compare(node.node, [newData])) {
        React.axios('/corp/department/sort', result).then(res => {
          // tipAlert({
          //     type: "success",
          //     msg: React.language("Invited.tip3")
          // })
          // this.props.getDeptList && this.props.getDeptList();
        }).catch(res => {
          this.setState({ treeData: oldTreeData, expandedKeys: oldExpandedKeys });
          // window.FX.Vip.showUpgradeTip(res.data.responseJSON)
        });
      }
    });
  }

  setTreeKey = (t) =>{
    this.setState({selectKey: t})
  }

  newParentOverNode = null;
  startNode = null;

  render() {

    const { treeData, rowHeight, selectKey, expandedKeys } = this.state;
    const { itemIcon, itemIconColor } = this.props;
    const newExpandedKeys = [...new Set(expandedKeys)];
    return (
      <Tree
        treeData={treeData}
        theme={customTheme}
        isVirtualized={false}
        defaultExpandedKeys={[1]}
        expandedKeys={newExpandedKeys}
        selectedKeys={[selectKey]}
        scaffoldBlockPxWidth={32}
        rowHeight={rowHeight}
        onClick={(e, node) => {
          if(node.type === "dockcorpdept"){
            return
          }
          this.handleNodeClick(node, e)
        }}
        onExpand={(expanded, node) => {
          this.newParentOverNode = null;
          this.setState({expandedKeys: expanded})
        }}
        draggable={BsyUtils.isCommon()}
        onDrop={(node, e) => {
          this.newParentOverNode = null;
          this.startNode = null;
          if(this.sortTime){
            clearTimeout(this.sortTime);
            this.sortTime = null;
          }
          this.handleMoveNode(node);
        }}
        onDragEnd={() => {
          if(this.sortTime){
            clearTimeout(this.sortTime);
            this.sortTime = null;
          }
          this.startNode = null;
        }}
        // onDragEnter={(node) => { console.log('onDragEnter',node) }}
        // onDragLeave={(node) => { console.log('onDragLeave',node) }}
        onDragOver={(node) => {
          let n = node.node;
          if (!this.newParentOverNode) {
            this.newParentOverNode = node;
          }
          if (this.newParentOverNode.node.key !== n.key) {
            let i = this.startNode.node;
            let hasChildGroup = false;

            if (i.children) {
              for (let f = 0; f < i.children.length; f++) {
                if (i.children[f].type === "group") {
                  hasChildGroup = true;
                }
              }
            }

            if (hasChildGroup) {
              return;
            } else {
              if (n.levelChild > 1) {
                return;
              }
            }

            if (this.sortTime) {
              clearTimeout(this.sortTime);
              this.sortTime = null;
            }

            if (!n.expanded) {
              this.sortTime = setTimeout(() => {
                node.context.triggerExpandActionExpand(node.event, n);
              }, 1500);
            }

            this.newParentOverNode = node;
          }
        }}
        onDragStart={(node) => { this.startNode = node; }}
        icon={(rowInfo) => {
          return <>
            <i className={`item-icon ${itemIcon ? itemIcon : 'icon-dept-title'}`} style={{color: itemIconColor ? itemIconColor : ""}}></i>
            {rowInfo.type !== "dockcorpdept" && <i
              className="icon-flow-other nav nav-department-edit"
              style={{
                verticalAlign: "middle"
              }}
              //自定义菜单点击
              onClick={this.handleCustomMenu({ ...rowInfo })}
            ></i>}
          </>
        }}
        switcherIcon={(rowInfo)=>{
          return <>
            <i className={(rowInfo.expanded ? 'icon-tree-collapse' : 'icon-tree-expand') + (rowInfo.data.children ? '' : ' hide')}></i>
          </>
        }}
      />
    );
  }
}